import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user_press",
  "use": "user_press-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"user_press\"><path d=\"M10 7.2c.6-.5 1-1.3 1-2.2 0-1.7-1.3-3-3-3S5 3.3 5 5c0 .9.4 1.7 1 2.2-1.7.5-3 2.1-3 4V14h10v-2.8c0-1.9-1.3-3.5-3-4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol